export default __webpack_public_path__ + "static/media/icon-insights-catering.775d507b.svg";